import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import api from './js/api'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import {getJwtToken} from "@/js/jwt.js";

axios.defaults.baseURL = process.env.VUE_APP_BASE_API
axios.defaults.headers.common['App'] = 'CMS';

Vue.http = Vue.prototype.$http = axios
Vue.urls = Vue.prototype.$urls = api

axios.interceptors.request.use(config => {
    if (!config.params) config.params = {}
    const authKey = localStorage.getItem('authKey') || sessionStorage.getItem('authKey')
    if (authKey) {
        config.params['auth_key'] = authKey
    } else {
        const token = getJwtToken();
        if (token) {
            config.params['token'] = token
        }
    }
    return config
}, undefined)

axios.interceptors.response.use(undefined, error => {
    if (error.response.status === 401) {
        router.push({path: '/login'})
    }
    return Promise.reject(error)
})

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
